import React, { PureComponent } from 'react'
import { Row, Col } from 'reactstrap'
import axios from 'axios'
import AddCategory from './AddCategory'
import RemoveCategory from './RemoveCategory'
import EditCategory from './EditCategory'
import alphabetizeBy from '../../../helpers/alphabetizeBy'
import authProtection from '../../../HOCs/authProtection'

class Categories extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      categories: []
    }
    this.fetchCategories = this.fetchCategories.bind(this)
  }

  componentDidMount() {
    this.fetchCategories()
  }

  fetchCategories() {
    axios
      .get('/api/proxy/v2/categories')
      .then(({ data }) => {
        const sorted = alphabetizeBy('categoryName', data)
        this.setState({ categories: sorted })
      })
      .catch(err => console.log(err))
  }

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col xs="12">
            <AddCategory refresh={this.fetchCategories} />
            <EditCategory
              categories={this.state.categories}
              refresh={this.fetchCategories}
            />
            <RemoveCategory
              categories={this.state.categories}
              refresh={this.fetchCategories}
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default authProtection(Categories)



// WEBPACK FOOTER //
// ./src/views/Pages/Categories/Categories.js